module.exports = __webpack_public_path__ + "img/202601_03.d78aa7fc.png";